var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Toolbar as MUIToolbar, Stack } from '@mui/material';
import { SaveButton } from 'react-admin';
import { NextButton } from './NextButton';
import { useWizardFormContext } from './useWizardFormContext';
import { PreviousButton } from './PreviousButton';
/**
 * The Toolbar displayed at the bottom of WizardForm.
 *
 * @prop {boolean} hasPreviousStep Optional. Does the wizard have a previous step?
 * @prop {boolean} hasNextStep Optional. Does the wizard have a next step?
 * @prop {Function} onPreviousClick Optional. Previous button click action
 * @prop {Function} onNextClick Optional. Next button click action
 * @prop {...BaseToolbarSubmitProps}
 */
export var WizardToolbar = function (props) {
    var children = props.children, rest = __rest(props, ["children"]);
    var hasNextStep = useWizardFormContext(props).hasNextStep;
    return (_jsx(MUIToolbar, __assign({}, sanitizeRestProps(rest), { children: children ? (children) : (_jsxs(Stack, { direction: "row", sx: {
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
            }, children: [_jsx(Box, { children: _jsx(PreviousButton, {}) }), _jsx(Box, { children: hasNextStep ? _jsx(NextButton, {}) : _jsx(SaveButton, {}) })] })) })));
};
var sanitizeRestProps = function (_a) {
    var currentStep = _a.currentStep, goToNextStep = _a.goToNextStep, goToPreviousStep = _a.goToPreviousStep, goToStep = _a.goToStep, steps = _a.steps, rest = __rest(_a, ["currentStep", "goToNextStep", "goToPreviousStep", "goToStep", "steps"]);
    return rest;
};
